module.exports = __webpack_public_path__ + "static/media/v25.91e44bde.mp4";